const rules = [
    {
        "id": "2-back",
        "name": "2-back",
        "description": "Vergleiche das angezeigte Symbol mit dem Symbol, was zwei Schritte vorher zu sehen war.",
        "offset": 2
    },
    {
        "id": "3-back",
        "name": "3-back",
        "description": "Vergleiche das angezeigte Symbol mit dem Symbol, das drei Schritte vorher zu sehen war.",
        "offset": 3
    },
    {
        "id": "4-back",
        "name": "4-back",
        "description": "Vergleiche das angezeigte Symbol mit dem Symbol, das vier Schritte vorher zu sehen war.",
        "offset": 4
    }
]


function choseRandomRule() {
    console.log("returning random rule")
    return rules[Math.floor(Math.random() * rules.length)];
}